import { useCallback, useEffect, useState } from 'react'

/**
 * Das globale Kürzel für „Schnell notieren" lesen und setzen (Abnahme F-Q4).
 *
 * Der Hauptprozess hält den Wert — nur er kann ihn registrieren. Deshalb hier
 * kein eigener Zustand, der auseinanderlaufen könnte: Was gesetzt wurde, gibt
 * er zurück, und genau das wird angezeigt.
 *
 * Im Web gibt es das Kürzel nicht; dort bleibt der Wert `null` und das Setzen
 * meldet `false`.
 */
export function useQuickAddShortcut(): {
  shortcut: string | null
  setShortcut: (accelerator: string | null) => Promise<boolean>
} {
  const [shortcut, setLocal] = useState<string | null>(null)

  useEffect(() => {
    let abgemeldet = false
    window.windowAPI?.getQuickAddShortcut?.()
      .then(wert => { if (!abgemeldet) setLocal(wert) })
      .catch(() => {})
    return () => { abgemeldet = true }
  }, [])

  const setShortcut = useCallback(async (accelerator: string | null) => {
    const setzen = window.windowAPI?.setQuickAddShortcut
    if (!setzen) return false
    const ergebnis = await setzen(accelerator)
    // Auch bei einer Absage übernehmen: Der Hauptprozess meldet dann das
    // bisherige zurück, und angezeigt gehört, was wirklich gilt.
    setLocal(ergebnis.shortcut)
    return ergebnis.success
  }, [])

  return { shortcut, setShortcut }
}
